<template>
  <div>
    <b-row v-if="mode == 'login'">
      <b-col> 
        <h3>Log In With Your NAB Account</h3>
        <b-alert variant="danger" :show="loginErrors && loginErrors.length > 0">
          <div v-for="error in loginErrors">
            {{error}}
          </div>
        </b-alert>
        <b-form @submit.prevent="onLogin">
          <b-form-group label="Username or Email Address" label-for="username" description="This is probably your email address.">
            <b-form-input id="username" v-model="username" required placeholder="User name"></b-form-input>
          </b-form-group>
          <b-form-group label="Password" label-for="password" description="This is your password for the NAB site, not the AAAAI site.">
            <b-form-input type="password" id="password" v-model="password" required placeholder="Password"></b-form-input>
          </b-form-group>
          <b-button type="submit" variant="primary">Log In</b-button>
        </b-form>
      </b-col>
      <b-col>
        <h3>Log In With Your AAAAI Account</h3>
        <p>Are you an AAAAI member? You can log in to My NAB using your AAAAI account.</p>
        <b-button type="submit" variant="primary" @click="onLoginViaEdibo">Log In with AAAAI Account</b-button>
      </b-col>
    </b-row>
    <b-row v-if="mode == 'signup'">
      <b-col>
        <h3>Sign Up</h3>
        <b-alert variant="danger" :show="signupErrors && signupErrors.length > 0">
          <div v-for="error in signupErrors">
            {{error}}
          </div>
        </b-alert>
        <b-form @submit.prevent="onSignup">
          <b-form-group label="Email Address" label-for="email" description="Your email address will also be your username.">
            <b-form-input id="email" v-model="username" required placeholder="Email Address"></b-form-input>
          </b-form-group>
          <b-form-group label="Password" label-for="password" description="This is your password for the NAB site, not the AAAAI site.">
            <b-form-input type="password" id="password" v-model="password" required placeholder="Password"></b-form-input>
          </b-form-group>
          <b-form-group label="Confirm Password" label-for="confirmPassword">
            <b-form-input type="password" id="confirmPassword" v-model="confirmPassword" required placeholder="Confirm Password"></b-form-input>
          </b-form-group>
          <b-button type="submit" variant="primary">Sign Up</b-button>
        </b-form>
      </b-col>
      <b-col>
        <h3>Why Sign up?</h3>
        <p>By signing up, you can receive notifications when allergen levels change at stations near you. You also get to use the My NAB dashboard, which displays allergen levels at all your stations at a glance.</p>
      </b-col>
    </b-row>
    <b-row v-if="mode == 'request'">
      <b-col>
        <h3>Reset Password</h3>
        <b-alert variant="danger" :show="requestErrors && requestErrors.length > 0">
          <div v-for="error in requestErrors">
            {{error}}
          </div>
        </b-alert>
        <b-alert variant="success" :show="isRequestEmailSent">
          An email has been sent to {{requestSentEmail}} with a password reset link.
        </b-alert>
        <b-form @submit.prevent="onRequest">
          <b-form-group label="User name or email address" label-for="username" description="This is your user name for the NAB site, not the AAAAI site.">
            <b-form-input id="username" v-model="username" required placeholder="User name"></b-form-input>
          </b-form-group>
          <b-button type="submit" variant="primary">Reset Password by Email</b-button>
        </b-form>
      </b-col>
      <b-col>
        <h3>Forgot Your Password?</h3>
        <p>Enter your username or email address and we'll send you an email to reset your password.</p>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <hr />
        <div class="text-center">
          <div v-if="mode != 'signup'">
            <b-link @click="mode = 'signup'">Sign up for a NAB account</b-link>
          </div>
          <div v-if="mode != 'login'">
            <b-link @click="mode = 'login'">Log in to your NAB account</b-link>
          </div>
          <div v-if="mode != 'request'">
            <b-link @click="mode = 'request'">Forgot your password?</b-link>
          </div>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import axios from "axios";
import CrudOperationsMixin from './CrudOperationsMixin.js'

export default {
  name: "AuthForm",
  mixins: [CrudOperationsMixin],
  props: [
    'defaultMode'
  ],
  data() {
    return {
      mode: 'login',
      isAuthenticated: false,
      username: '',
      password: '',
      confirmPassword: '',

      requestSentEmail: null,
      isRequestEmailSent: false,

      loginErrors: [],
      signupErrors: [],
      requestErrors: []
    }
  },
  computed:{
  },
  methods: {
    processAuthResponse: function (authResponse) {
      axios.defaults.headers.common['Authorization'] = "Bearer " + authResponse.jwtToken;
      this.$root.$data.authenticatedUser.username = authResponse.applicationUser.userName;
      this.$root.$data.authenticatedUser.id = authResponse.applicationUser.id;
      this.$root.$data.authenticatedUser.roles = authResponse.roles;
      this.$root.$data.authenticatedUser.stationRoles = authResponse.applicationUser.roles;

      localStorage.setItem('jwt', authResponse.jwtToken);
      localStorage.setItem('username', authResponse.applicationUser.userName);
      localStorage.setItem('id', authResponse.applicationUser.id);
      localStorage.setItem('roles', JSON.stringify(authResponse.roles));
      localStorage.setItem('stationRoles', JSON.stringify(authResponse.applicationUser.roles));

      this.$emit('onAuthComplete');
    },
    onLogin() {
      this.query('/graphql/public', {
        query: `
          mutation ($logIn: LogInInputOGT!) {
            logIn(logIn: $logIn) {
              applicationUser {
                id,
                userName,
                roles {
                  id,
                  type,
                  station {
                    id,
                    displayCity,
                    name
                  }
                }
              }
              roles,
              jwtToken
            }
          }`,
        variables: {
          'logIn': { 
            "userName": this.username,
            "password": this.password
          }
        }}, (data) => {
          if (data.logIn) {
            this.processAuthResponse(data.logIn);
          }
        }, (errors) => {
          this.loginErrors = errors.map(x => x.message);
        });
    },
    onLoginViaEdibo() {
      let ssoUrl = window.location.protocol + '//' + window.location.host + '/edibo-sso.html';
      let postLoginUrl = window.location.protocol + '//' + window.location.host + '/edibo-handler.html';
      let authUrl = 'https://aaaai.execinc.com/edibo/NABLogin?PostLoginURL=' + encodeURIComponent(postLoginUrl) + '&ReturnURL=' + encodeURIComponent(ssoUrl);
      //let authUrl = 'https://test-aaaai.execinc.com/edibo/NABLogin?PostLoginURL=' + encodeURIComponent(postLoginUrl) + '&ReturnURL=' + encodeURIComponent(ssoUrl);
      console.log(authUrl);
      //debugger
      let authWindow = window.open(authUrl, 'authWindow');
    },
    onSignup() {
      if (this.password != this.confirmPassword) {
        this.signupErrors = ['Your password and confirmation do not match. Please try again.']
        return;
      }

      this.query('/graphql/public', {
        query: `
          mutation ($register: RegisterInputOGT!) {
            register(register: $register) {
              applicationUser {
                id,
                userName,
                roles {
                  id,
                  type,
                  station {
                    id,
                    displayCity,
                    name
                  }
                }
              }
              roles,
              jwtToken
            }
          }`,
        variables: {
          'register': { 
            "userName": this.username,
            "email": this.username,
            "password": this.password
          }
        }}, (data) => {
          if (data.register) {
            this.processAuthResponse(data.register);
          }
        }, (errors) => {
          this.signupErrors = errors.map(x => x.message);
        });
    },
    onRequest() {
      this.query('/graphql/public', {
        query: `
          mutation ($forgotPassword: ForgotPasswordInputOGT!) {
            forgotPassword(forgotPassword: $forgotPassword) {
              email
            }
          }`,
        variables: {
          'forgotPassword': { 
            "userNameOrEmail": this.username
          }
        }}, (data) => {
          this.requestSentEmail = data.forgotPassword.email;
          this.isRequestEmailSent = true;
        }, (errors) => {
          this.requestSentEmail = null;
          this.isRequestEmailSent = false;
          this.requestErrors = errors.map(x => x.message);
        });
    },
    loadAuth() {
      axios.defaults.headers.common['Authorization'] = "Bearer " + localStorage.getItem('jwt');
      this.$root.$data.authenticatedUser.username = localStorage.getItem('username');
      this.$root.$data.authenticatedUser.id = localStorage.getItem('id');
      this.$root.$data.authenticatedUser.roles = JSON.parse(localStorage.getItem('roles'));
      this.$root.$data.authenticatedUser.stationRoles = JSON.parse(localStorage.getItem('stationRoles'));
    }
  },
  watch: {
    mode: function (newValue, oldValue) {
      this.$emit('update:mode', newValue);
    }
  },
  mounted () {
    this.mode = this.defaultMode;

    window.addEventListener('message', message => {
      if (message.data == 'RefreshAuth') {

        // Check if the auth succeeded -- if not, make sure the EDiBO Login group is actually calling edibo-handler.html
        if (localStorage.getItem('jwt') == null) {
          this.$root.$children[0].showToast('Something went wrong while trying to sign in using your AAAAI account. Make sure you have a valid AAAAI account and try again, or create or log in with a My NAB account instead.', {
            title: 'Unable to Sign In',
            variant: 'danger',
            autoHideDelay: 5000
          });

          return;
        }

        this.loadAuth();
        this.$emit('onAuthComplete');
      }
    }, false);

    if (localStorage.getItem('jwt') == null)
      return;

    this.loadAuth();
  }
};
</script>